'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGdprConsentToProcessEnabled = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('./keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getGdprConsentToProcessEnabled = exports.getGdprConsentToProcessEnabled = (0, _getIn2.default)(_keyPaths.GDPR_CONSENT_TO_PROCESS_ENABLED);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/message/getGdprConsentToProcessEnabled.js
// module id = 908
// module chunks = 2 3